// extracted by css-extract-rspack-plugin
export default {"sourceDataHeader":"MFmQE","sourceDataRow":"WDEA2","sourceFeedbackButton":"x_nWw","sourceItemLink":"HD1s4","sourceItemTitleText":"m5HOm"};